import { render, staticRenderFns } from "./InstallmentsInfoBox.vue?vue&type=template&id=e4726ca6"
import script from "./InstallmentsInfoBox.vue?vue&type=script&lang=js"
export * from "./InstallmentsInfoBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports